import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import enums from 'util/enums';

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: ['Draft']
});

export const draftApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listDrafts: build.query({
      async queryFn(args) {
        const {
          skip,
          pageSize,
          includeData = true,
          returnMeta = true,
          orderBy = 'Created',
          orderDirection = 'desc'
        } = args || {};

        try {
          const res = await api.Enumeration(
            enums.ENUMERATION_TYPES.SIGNINGDRAFT,
            {
              Skip: skip,
              MaxResults: pageSize,
              IncludeData: includeData,
              returnMeta: returnMeta,
              OrderBy: orderBy,
              OrderDirection: orderDirection
            }
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      keepUnusedDataFor: 60,
      providesTags: [{ type: 'Draft', id: 'LIST' }]
    }),

    createDraft: build.mutation({
      async queryFn(payload) {
        try {
          const res = await api.SigningDraft.create(payload || {});
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'Draft', id: 'LIST' }]
    }),

    updateDraft: build.mutation({
      async queryFn(args) {
        try {
          const { guid, additionalData = null, body } = args || {};
          const res = await api.SigningDraft.update(guid, {
            AdditionalData: additionalData,
            Body: body
          });
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'Draft', id: 'LIST' }]
    }),

    removeDraft: build.mutation({
      async queryFn(guid) {
        try {
          const res = await api.SigningDraft.remove(guid);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'Draft', id: 'LIST' }]
    })
  })
});

export const {
  useListDraftsQuery,
  useCreateDraftMutation,
  useUpdateDraftMutation,
  useRemoveDraftMutation
} = draftApi;
